import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { SiteProvider } from "@/lib/SiteContext";
import HomePage from "@/pages/HomePage";
import PageView from "@/pages/PageView";
import ProductPage from "@/pages/ProductPage";
import AdminLogin from "@/admin/AdminLogin";
import AdminApp from "@/admin/AdminApp";

export default function App() {
  return (
    <SiteProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/p/:slug" element={<PageView />} />
          <Route path="/product/:slug" element={<ProductPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminApp />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </SiteProvider>
  );
}
